<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header">
				<h1>{{ $t($route.name) }}</h1>
			</div>
		</div>
	</section>
	<!-- Main Content -->
	<div class="container-fluid" v-if="dataReady">
		<div class="row mt-2">

			<div class="col-lg-6 col-md-12 stats-col">
				<div class="card sameheight-item stats" style="min-height: 400px;">
					<h4 class="card-header">В мрежата</h4>
					<div class="card-block">
						<div class="row row-sm stats-container">
							<div class="col-12 col-sm-6 stat-col" v-for="(dashCounter,key) in $config.basicLists.dashCounters">
								<div class="stat-icon">
								<router-link :to="dashCounter.link"><i class="fa text-success" :class="dashCounter.icon"></i></router-link>
								</div>
								<div class="stat">
									<div class="value"> {{ report[key] }} </div>
									<div class="name"> <router-link :to="dashCounter.link"  class="text-muted">{{ dashCounter.title }}</router-link> </div>
								</div>
								<div class="stat-border"></div>
							</div>
							<div class="col-12 col-sm-6  stat-col" v-for="(resourceType,key) in $config.basicLists.resourceTypes">
								<div class="stat-icon">
									<router-link :to="resourceType.link"><i class="fa text-success" :class="resourceType.icon"></i></router-link>
								</div>
								<div class="stat">
									<div class="value"> {{ report.resources[key] }} </div>
									<div class="name"> <router-link :to="resourceType.link" class="text-muted">{{ resourceType.title }}</router-link> </div>
								</div>
								<div class="stat-border"></div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 col-md-12">
				<div class="card map-card" style="min-height: 400px">
					<h4 class="card-header">Семейства в България</h4>
					<div class="card-block">
						<div id="bgMap" class="map"></div>
					</div>
				</div>
			</div>
		</div>

		<div class="row mt-2">
			<div class="col-lg-6 col-md-12">
				<div class="card" style="min-height: 400px">
				<h4 class="card-header">История</h4>
				<div class="card-block">
					<div class="row" v-if="dataHistoryReady">
						<div class="col-sm-12">
							<ul class="timeline">
								<li v-for="(item, index) in history_records.items" :class="{'timeline-inverted': index % 2 === 0}">
									<div class="timeline-badge" :class="$config.basicLists.eventTypes[item.event_type].color">
										<i class="fa" :class="$config.basicLists.eventTypes[item.event_type].icon"></i></div>
									<div class="timeline-panel">
											<div class="timeline-body">
											<p>
												<c-avatar :family="item.family" class="float-left"></c-avatar>
												<span>Семейство {{ item.family.name }}
												{{ $config.basicLists.eventTypes[item.event_type].text }}
												<router-link v-if="item.event_type !== 'new-family'"
												:to="$config.basicLists.eventTypes[item.event_type].link + item.target_id">
													{{ item.info.title }}
												</router-link>
												</span>
												<br>
												<span class="text-muted"><i class="fa fa-clock-o" :title="item.createdAt | prettyDateTime"></i> {{ item.createdAt | fromNowDateTime }}</span>
											</p>
											</div>
									</div>
								</li>
							</ul>
						</div>
						<div class="col-sm-12 text-center">
							<router-link to="/events">
								<button type="button" class="btn btn-green">Виж всички</button>
							</router-link>
						</div>
					</div>
				</div>
				</div>
			</div>

			<div class="col-lg-6 col-md-12">
				<div class="card">
				<h4 class="card-header">Информация</h4>
				<div class="card-block">
					Описание на менюто:
					<table class="table table-hover table-responsive">
						<tbody>
							<tr v-for="(menuItem,key) in $config.basicLists.menuItems">
								<td>
									<router-link :to="menuItem.link" class="text-nowrap">
										<i class="fa fa-lg text-success" :class="menuItem.icon"></i>&nbsp;<span>{{menuItem.title}}</span>
									</router-link>
								</td>
								<td>{{menuItem.comment}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
var jQuery = require('jquery');
require('jvectormap-next');
var mapBgBg = require('../../assets/jquery-jvectormap-data-bg-bg.js');
jQuery.fn.vectorMap('addMap', 'bg_bg', mapBgBg);

module.exports = {
	data: function () {
		return {
			report: '',
			history_records: [],
			dataReady: false,
			dataHistoryReady: false
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	beforeDestroy: function () {
		jQuery(this.$el).find('.jvectormap-container').each((i, el) => jQuery(el).data('mapObject').remove());
	},
	methods: {
		fetchData: function () {
			this.$http.get('backend://report/total').then((result) => {
				this.report = result.body;
				this.dataReady = true;

				var mapData = {};
				for (var state in this.$config.lists.states) {
					var oState = this.$config.lists.states[state];
					if (this.report.cnt_by_state[state]) {
						mapData['BG-' + oState.code] = this.report.cnt_by_state[state];
					}
				}
				setTimeout(() => this.showMap('bgMap', mapData), 0);
			}).catch(this.$http.toastCatcher);

			this.$http.get('backend://history?limit=5').then((result) => {
				this.history_records = result.body;
				this.dataHistoryReady = true;
			}).catch(this.$http.toastCatcher);
		},
		showMap: function (mapID, mapData) {
			var mapName = 'bg_bg';
			jQuery('#' + mapID).vectorMap({
				map: mapName,
				backgroundColor: 'transparent',
				regionLabelStyle: {
					initial: {
						'font-family': 'Roboto',
						'font-weight': 'normal'
					}
				},
				regionStyle: {
					initial: {
						'fill': '#ffffff',
						'fill-opacity': 1,
						'stroke-width': 1,
						'stroke': '#7d8286'
					}
				},
				series: {
					regions: [{
						values: mapData,
						scale: ['#a9d7a9', '#5cb85c'],
						normalizeFunction: 'polynomial'
					}]
				},
				labels: {
					regions: {
						render (code) {
							return code.split('-')[1];// + ':' + num
						},
						offsets: function(code) {
							var map = mapBgBg;
							return map.paths[code] ? map.paths[code].offset : undefined;
						}
					}
				},
				onRegionTipShow (e, tip, code) {
					var num = '0';
					if (typeof mapData[code] !== 'undefined') {
						num = mapData[code];
					}
					tip.text(tip.text() + ': ' + num);
				},
				zoomAnimate: true
			});
		}
	}
};
</script>
<style>
.map-card .card-block {
	height: 100%;
	position: absolute;
	width: 100%;
	top: 0;
	padding-top: 5.25rem;
}

.map-card .card-block {
	height: 100%;
	position: absolute;
	width: 100%;
	top: 0;
	padding-top: 5.25rem;
}

#bgMap {
	height: 100%;
}

#bgMap .jvectormap-zoomin {
	right: 10px;
	bottom: 30px;
	top: initial;
	left: initial;
}

#bgMap .jvectormap-zoomout {
	right: 10px;
	bottom: 10px;
	top: initial;
	left: initial;
}

.stats .stat-col {
	margin-bottom: 20px;
	float: left;
	white-space: nowrap;
	overflow: hidden;
	padding: 5px;
}

.stats .stat-icon {
	display: inline-block;
	font-size: 26px;
	text-align: center;
	vertical-align: middle;
	width: 50px;
}

.stats .stat {
	vertical-align: middle;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: inline-block;
	margin-right: 10px;
	font-size: 1.1em;
}

.stats .stat .value {
	font-weight: 400;
	font-size: 1.1em;
}

.stats .stat-border {
	border-bottom: 3px solid #e9ecef;
	margin: 5px;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?50ce2473